module.exports = __webpack_public_path__ + "static/media/icons-system-chevron-left.5e9545c8.svg";